import React, { Component } from 'react';
import { Checkbox } from '../checkbox';
import { connectRefinementList } from 'react-instantsearch/connectors';
import {
  FilterSection,
  FilterHeading,
  FilterRow,
  FilterRowDescription,
  FilterCount,
  FilterCountText,
  SectionToggle,
  RefinementCount,
} from './style';
import { BaseButton } from '../buttons';
import { Collapse } from 'react-collapse';
import ArrowRight from '../../images/arrowRight';
import { FlexCol, FlexRowBetween } from '../misc';

// TODO: where to put those?
class FilterRefinement extends Component {
  handleRefinement = value => {
    const { canRefine, refine } = this.props;
    if (canRefine) {
      refine(value);
    }
  };

  setRefinementCount = count => {
    this.props.setRefinementCount(count);
  };

  componentDidUpdate = () => {
    const { setRefinementCount, items } = this.props;
    setRefinementCount(
      items.reduce((acc, val) => {
        const { isRefined } = val;
        if (isRefined) acc += 1;
        return acc;
      }, 0)
    );
  };

  render() {
    const { items } = this.props;
    return (
      <FlexCol>
        {items.map((item, key) => {
          const { label, count, isRefined } = item;
          return (
            <FilterRow key={key}>
              <Checkbox
                type="checkbox"
                checked={isRefined}
                onChange={() => this.handleRefinement(item.value)}
              />
              <FilterRowDescription>{label}</FilterRowDescription>
              <FilterCount>
                <FilterCountText>{count}</FilterCountText>
              </FilterCount>
            </FilterRow>
          );
        })}
      </FlexCol>
    );
  }
}

const ConnectedFilterRefinement = connectRefinementList(FilterRefinement);

class FilterRefinementSection extends Component {
  state = { refinementCount: null };

  setRefinementCount = count => {
    this.setState({ refinementCount: count });
  };

  render() {
    const {
      attribute,
      label,
      sectionIsOpen,
      toggle,
      operator,
      transformItems,
    } = this.props;
    const { refinementCount } = this.state;
    return (
      <FilterSection>
        <FlexCol
          css={`
            position: relative;
          `}
        >
          <BaseButton
            css={`
              width: 100%;
            `}
            onClick={() => toggle(attribute)}
          >
            <FlexRowBetween
              css={`
                width: 100%;
                min-height: 25px;
              `}
            >
              <FilterHeading>{label}</FilterHeading>
              <SectionToggle>
                <RefinementCount show={!sectionIsOpen && refinementCount > 0}>
                  {refinementCount}
                </RefinementCount>

                <ArrowRight
                  width={20}
                  height={20}
                  transform={sectionIsOpen ? 'rotate(90)' : ''}
                />
              </SectionToggle>
            </FlexRowBetween>
          </BaseButton>
          <Collapse isOpened={sectionIsOpen && refinementCount != null}>
            <ConnectedFilterRefinement
              attribute={attribute}
              operator={operator}
              transformItems={transformItems}
              setRefinementCount={this.setRefinementCount}
              showMoreLimit={20}
              limit={20}
            />
          </Collapse>
        </FlexCol>
      </FilterSection>
    );
  }
}

export default FilterRefinementSection;



// WEBPACK FOOTER //
// ./src/components/filter/filterCheckbox.js